import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {AppController} from "../app-controller";

export class AppModuleProps extends BaseModuleProps {
  controller: AppController;
}
